import { Poptional, Subpoptional } from './poptional';
import { Utils } from '../helpers/utils';

export class PoptionalSelection {
	id: number;
	local_id: number;
	qty: number;
	name: string;
	subpoptionals: {
		id: number;
		local_id: number;
		qty: number;
		name: string;
		unPrice: number;
		totalPrice: number;
		minReached: boolean;
		maxReached: boolean;
		selectionType: 'buttons'|'check';
	}[]|null;

	unPrice: number;
	totalPrice: number;
	minReached: boolean;
	maxReached: boolean;
	itemQty: number;
	poptional: Poptional;
	selectionType: 'buttons'|'check';

	// descriptions() is called straight from templates (e.g. cart/checkout
	// lists) inside @for loops that track by identity. Without caching, every
	// call returns brand-new array/objects, so Angular sees a "new"
	// collection on every change-detection pass and tears down/rebuilds the
	// DOM in a loop (NG0956), which then trips NG0100. Cache the result and
	// only invalidate when quantities actually change.
	private _descriptionsCache: {qty: number, text: string, price: number}[] | null = null;

	lessQty(index: number|null = null) {
		if(index != null) {
			if(!this.subpoptionals || !this.subpoptionals[index] || this.subpoptionals[index].qty <= 0) {
				return;
			}
			this.subpoptionals[index].qty -= 1;
		} else {
			if(this.qty <= 0) {
				return;
			}
			this.qty -= 1;
		}
		this.checkQuantities();
	}
	moreQty(index: number|null = null) {
		if(this.maxReached) {
			return;
		}
		if(index != null) {
			if(!this.subpoptionals || !this.subpoptionals[index] || this.subpoptionals[index].maxReached) {
				return;
			}
			this.subpoptionals[index].qty += 1;
		} else {
			this.qty += 1;
		}
		this.checkQuantities();
	}

	canToggle(index: number|null = null): boolean {
		if(index == null) {
			return this.qty > 0 || !this.maxReached;
		}
		if(!this.subpoptionals || !this.subpoptionals[index]) {
			return false;
		}
		return this.subpoptionals[index].qty > 0 || !this.maxReached;
	}

	checkQuantities() {
		this._descriptionsCache = null;
		let indiv = this.poptional && this.poptional.individual;
		let factor = indiv ? this.itemQty : 1;
		this.totalPrice = 0;
		if(this.poptional && this.poptional.subpoptionals && this.poptional.subpoptionals.length > 0 && this.subpoptionals) {
			let aux = 0;
			for(let i = 0; i < this.poptional.subpoptionals.length; i++) {
				let subPop = this.poptional.subpoptionals[i];
				let subSel = this.subpoptionals[i];
				if(!subSel) {
					continue;
				}

				aux += subSel.qty;
				subSel.totalPrice = Number((subSel.qty * subSel.unPrice * (indiv ? 1 : this.itemQty)).toFixed(2));
				this.totalPrice += subSel.totalPrice;
				let subMin = subPop.min_qty || 0;
				subSel.minReached = subSel.qty <= subMin * factor;
				subSel.maxReached = subPop.max_qty == null ? false : subSel.qty >= subPop.max_qty * factor;
			}

			this.qty = aux;
		} else {
			this.totalPrice += Number((this.qty * this.unPrice * (indiv ? 1 : this.itemQty)).toFixed(2));
		}

		let min = (this.poptional && this.poptional.min_qty) || 0;
		let max = this.poptional ? this.poptional.max_qty : null;
		this.minReached = this.qty >= min * factor;
		this.maxReached = max == null ? false : this.qty >= max * factor;
	}

	clear() {
		this.qty = 0;
		if(this.subpoptionals) {
			for(let subp of this.subpoptionals) {
				subp.qty = 0;
			}
		}
		this.checkQuantities();
	}

	descriptions(): {qty: number, text: string, price: number}[] {
		if(this._descriptionsCache) {
			return this._descriptionsCache;
		}

		let aux = [];
		if(!this.subpoptionals) {
			if(this.qty > 0) {
				aux.push({qty: this.qty, text: this.poptional ? this.poptional.name : this.name, price: this.totalPrice});
			}
			this._descriptionsCache = aux;
			return aux;
		}

		if(this.subpoptionals.length > 0) {
			for(let i = 0; i < this.subpoptionals.length; i++) {
				if(this.subpoptionals[i].qty == 0)
					continue;

				let text = (this.poptional && this.poptional.subpoptionals && this.poptional.subpoptionals[i])
					? this.poptional.subpoptionals[i].name
					: this.subpoptionals[i].name;
				aux.push({
					qty: this.subpoptionals[i].qty,
					text: text,
					price: this.subpoptionals[i].totalPrice
				});
			}
		} else if(this.qty > 0) {
			aux.push({qty: this.qty, text: this.poptional ? this.poptional.name : this.name, price: this.totalPrice});
		}
		this._descriptionsCache = aux;
		return aux;
	}

	constructor(json: any, itemQty: number = 1) {
		for(let prop in json)
			this[prop] = json[prop];

		this.itemQty = itemQty;
	}
	static fromJsonArray(selections: any[], itemQty: number = 1): PoptionalSelection[] {
		let aux = [];
		if(!selections) {
			return aux;
		}
		for(let selection of selections) {
			aux.push(new PoptionalSelection(selection, itemQty));
		}
		return aux;
	}
	static createDefault(poptional: Poptional, itemQty: number = 1): PoptionalSelection {
		let factor = poptional.individual ? itemQty : 1;
		let json: any = {
			poptional: poptional,
			id: poptional.id,
			local_id: poptional.local_id || poptional.id,
			qty: 0,
			name: poptional.name,
			subpoptionals: [],
			selectionType: ((poptional.max_qty || 0) * factor) == 1 ? 'check':'buttons',
			unPrice: Number(poptional.un_price || '0')
		};
		if(poptional.subpoptionals) {
			for(let sub of poptional.subpoptionals) {
				let json2 = {
					id: sub.id,
					local_id: sub.local_id || sub.id,
					qty: 0,
					name: sub.name,
					selectionType: sub.max_qty == 1 ? 'check':'buttons',
					unPrice: Number((Number(poptional.un_price || '0') + Number(sub.un_price || 0)).toFixed(2))
				};
				json.subpoptionals.push(json2);
			}
		}
		let aux = new PoptionalSelection(json, itemQty);
		aux.checkQuantities();
		return aux;
	}
	static sumValues(poptionalSelections: PoptionalSelection[]): number {
		if(poptionalSelections == null)
			return 0;

		let total = 0;
		for(let sel of poptionalSelections) {
			total += sel.totalPrice || 0;
		}
		return total;
	}
}
